import { AllActions } from "../actions";
import { Results } from "../../interfaces";
import * as constants from "../constants";
import { messages } from "../../refdata/UserMessages";

export const initialResultsState: Results = {};

export function results(
  state: Results = initialResultsState,
  action: AllActions,
): Results {
  switch (action.type) {
    case constants.RECEIVE_RESULTS_FAILURE:
      return {
        ...state,
        error: {
          message: messages.error.fetchResultsFailure,
          detail: String(action.error),
        },
      };
  }
  return state;
}
